import React from 'react';

import { twMerge } from 'tailwind-merge';

import { getColorType, getStrokeWidth } from './util';

interface LoaderProps {
  readonly type?: 'spinner' | 'ellipsis';
  readonly size?: number;
  readonly duration?: number;
  readonly className?: string;
}

const ELLIPSIS_ARRAY = [0, 1, 2, 3];

interface CircleProps {
  readonly duration: number;
  readonly index: number;
}

function Circle({ duration, index }: CircleProps) {
  return (
    <circle
      cx="0"
      cy="50"
      r="10"
      className="origin-center animate-loading"
      style={{
        animationDelay: `${(-duration * (4 - index)) / 4}s`,
        animationDuration: `${duration}s`,
      }}
    />
  );
}

const Loader = React.memo(function Loader({ type = 'spinner', size = 24, duration = 2500, className }: LoaderProps) {
  const _duration = duration / 1000;
  const classes = twMerge(`${getColorType(type)}`, className);

  return type === 'ellipsis' ? (
    <svg role="status" aria-busy="true" width={size} height={size} viewBox="0 0 100 100" preserveAspectRatio="xMidYMid" className={classes}>
      {ELLIPSIS_ARRAY.map((i) => {
        return <Circle key={i} index={i} duration={_duration} />;
      })}
    </svg>
  ) : (
    <svg role="status" aria-busy="true" width={size} height={size} viewBox="0 0 100 100" preserveAspectRatio="xMidYMid" className={classes}>
      <circle cx="50" cy="50" r="30" strokeWidth={getStrokeWidth(size)} strokeLinecap="round" fill="none">
        <animateTransform
          attributeName="transform"
          type="rotate"
          repeatCount="indefinite"
          dur={`${_duration}s`}
          values="0 50 50;180 50 50;720 50 50"
          keyTimes="0;0.5;1"
        />
        <animate
          attributeName="stroke-dasharray"
          repeatCount="indefinite"
          dur={`${_duration}s`}
          values="18.84955592153876 169.64600329384882;94.2477796076938 94.24777960769377;18.84955592153876 169.64600329384882"
          keyTimes="0;0.5;1"
        />
      </circle>
    </svg>
  );
});

export { Loader };
